var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"compareContractsPage"}},[_c('MainLayout',[(_vm.contractInformations && _vm.contractInformations.length)?_c('b-row',[_c('CompareEditions',{attrs:{"contract-informations":_vm.contractInformations}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }